import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import Text from 'components/Text';
import useCallbackRef from 'hooks/useCallbackRef';
import ButtonPanel from './ButtonPanel';
import { useAutoCompletion } from '../AutoCompleteWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var linkDescriptionId = 'open-external-link-description';
var ExternalLinkPanel = function ExternalLinkPanel(_ref) {
  var asset = _ref.asset,
    link = _ref.link,
    autoCompleteEnabled = _ref.autoCompleteEnabled,
    onLoad = _ref.onLoad,
    onComplete = _ref.onComplete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onLoadRef = useCallbackRef(onLoad);

  // as links don't actually get "loaded" per se, we just call `onLoad` right away
  useEffect(function () {
    if (asset) {
      onLoadRef.current();
    }
  }, [asset, onLoadRef]);
  var _useAutoCompletion = useAutoCompletion({
      autoCompleteEnabled: autoCompleteEnabled,
      userContentStatus: asset.userContentStatus,
      onComplete: onComplete
    }),
    markAsCompleted = _useAutoCompletion.markAsCompleted;

  // FYI window.open is needed for microsite popup window
  // as popup would try to send notification to the hub using:
  // window.opener.postMessage(...);
  // when used as a link, window.opener is null
  var buttonProps = {
    onClick: function onClick() {
      window.open(link, '_blank');
      markAsCompleted();
    }
  };
  return /*#__PURE__*/_jsxs(ButtonPanel, {
    asset: asset,
    imageButtonProps: buttonProps,
    children: [/*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
      variant: "primary",
      icon: "external",
      "aria-describedby": linkDescriptionId,
      children: t('actions_open_link')
    })), /*#__PURE__*/_jsx(Text, {
      dimmed: true,
      as: "p",
      size: "s",
      mt: "xs",
      id: linkDescriptionId,
      children: t('external_link_opens_in_new_tab')
    })]
  });
};
export default ExternalLinkPanel;